import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '@/store';
import { selectNeedsPasswordSetup } from '@/store/slices/authSlice';
import { Sparkles } from 'lucide-react';

/**
 * Migration banner shown to users who haven't set a password yet.
 * Driven by meta.needsPasswordSetup from the store details API.
 * Rendered as a soft sky-blue rounded bar in the main layout.
 * Not dismissible — persists until the user sets a password.
 */
const MigrationBanner: React.FC = () => {
    const navigate = useNavigate();
    const needsPasswordSetup = useAppSelector(selectNeedsPasswordSetup);

    if (!needsPasswordSetup) {
        return null;
    }

    return (
        <div className="w-full">
            <div className="w-full bg-[#EBF5FF] border border-[#BFDBFE] rounded-xl px-5 py-3 flex items-center justify-between">
                <div className="flex items-center gap-3">
                    <div className="w-7 h-7 rounded-lg bg-[#DBEAFE] flex items-center justify-center flex-shrink-0">
                        <Sparkles className="w-3.5 h-3.5 text-[#3B82F6]" />
                    </div>
                    <div>
                        <p className="text-[13px] font-[550] text-[#1E3A5F]">
                            Compra now has its own login!
                        </p>
                        <p className="text-[12px] text-[#5B8DB8] mt-0.5">
                            Set a password to access your dashboard anytime — no Shopify required.
                        </p>
                    </div>
                </div>
                <button
                    onClick={() => navigate('/settings')}
                    className="h-8 px-4 rounded-lg text-[12px] font-[600] bg-[#3B82F6] text-white hover:bg-[#2563EB] transition-all duration-150 shadow-sm flex-shrink-0"
                >
                    Set Password
                </button>
            </div>
        </div>
    );
};

export default MigrationBanner;
